import React from "react"
import {
  Container,
  Col,
  Row
} from 'reactstrap';


function HomeScreen(){
    return(
        <div className="containhome">
          <Container fluid className="homepage fullscreen">
          <Row className="justify-content-center align-items-center"></Row>
            <Row className="justify-content-center align-items-center">
              <Col xl="6" lg="7" md="9" xs="12" className="text-left">
                <p>&nbsp;</p>
                <h1 className="display-1 home-1 text-center">
                The failed <br/>deals of the century
                </h1>
                <h2 className="display-5 home-4 text-center">
                We read all 181 pages of Trump's Middle East Peace Plan to find out how the 'deal of the century' compares with the last 100 years of Israeli-Palestinian negotiations.
                </h2>

              </Col>
            </Row>
            <Row className="justify-content-center align-items-end">
            <Col className='text-center'><a href="#arrow"><img className="arrow" src='./jpg/down.png' width="60px" height="auto" alt=""/></a></Col>
            </Row>
          </Container>

          <Container id="arrow" fluid className="khaldungrey">
          <Container className="introduction">
            <Row>
            <Col lg="9" md="10" sm="10" xs="12" className="text-left">
                      <br/>
                      <br/>
                     <p  className="text-white explaintext">On January 28, 2020, US President Donald Trump formally announced his long-awaited Middle East Peace Plan to resolve the seven-decade-long Israeli–Palestinian conflict.</p>
                     <p className="text-white explaintext">He hailed it as "the deal of the century".</p>
                     <p className="text-white explaintext">But is this new plan any different from the many previous deals and declarations that have tried to determine the fate of the Palestinian people?</p>
                     <p className="text-white explaintext">To find out, we read all 181 pages of Trump's “Vision for Peace” and compared it to the most notable documents on the Israeli-Palestinian conflict starting with the Balfour Declaration of 1917.</p>

                     <h2 className="display-3 text-white">The failed deals of the century - visualised:</h2>
<div className="embed-responsive embed-responsive-16by9">
		<iframe title="trump plan explainer" className="embed-responsive-item" id="explainerT" src="https://player.vimeo.com/video/393844487"></iframe>
	</div>
    <br/>
                     <br/>

            </Col>
            </Row>
        </Container>
        </Container>
          </div>
    )
}
export default HomeScreen

